var Curriculog = Curriculog || {};

Curriculog.UserPreferencesView = (function ($, _, Backbone, UserPreferencesView) {

    UserPreferencesView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/userPreferences.html',
        events: {
        },

        initialize: function (options) {
            this.preferences = options.preferences;
            this.render();
        },

        render: function () {
            this.el = nunjucks.render(this.template, this.preferences);
            this.replaceElement(this.el);
            for (var key in this.preferences) {
                var theElement = $(this.el).find('#'+key+' > [value="'+this.preferences[key].value+'"]');
                theElement.prop('selected', true);
            }

        },
    });
    return UserPreferencesView;

})($, _, Backbone, Curriculog.UserPreferencesView || {});
